import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { DontHavePermission } from '../components/DontHavePermission/DontHavePermission';
import ForbiddenErrorBoundary from '../components/ErrorBoundary/ForbiddenErrorBoundary';
import globalErrorHandler from '../services/globalErrorHandler';

export const ElementWrapper = ({ isHasPermission = true, component: Component, headerText, ...rest }) => {
  const [hasForbiddenError, setHasForbiddenError] = useState(false);
  const location = useLocation();

  // Clear error when route changes (including query parameters)
  useEffect(() => {
    setHasForbiddenError(false);
    globalErrorHandler.clearError();
  }, [location.pathname, location.search]);

  useEffect(() => {
    // Subscribe to global error handler
    const unsubscribe = globalErrorHandler.subscribe(() => {
      setHasForbiddenError(true);
    });

    // Clean up on unmount
    return () => {
      unsubscribe();
    };
  }, []);

  /**
   * You can use url params or location object using useParams, useLocation from react-router-dom
   * Also if you need to use history.push or something like this you must use useNavigate hook
   */

  // Show DontHavePermission if either permission check fails or 403 error occurs
  if (!isHasPermission || hasForbiddenError) {
    return <DontHavePermission headerText={headerText} showBackButton={hasForbiddenError} />;
  }

  // Wrap component with ErrorBoundary to catch synchronous errors
  return (
    <ForbiddenErrorBoundary headerText={headerText}>
      <Component headerText={headerText} {...rest} />
    </ForbiddenErrorBoundary>
  );
};

ElementWrapper.propTypes = {
  component: PropTypes.oneOfType([PropTypes.element.isRequired, PropTypes.elementType.isRequired]),
  headerText: PropTypes.string,
  rest: PropTypes.object,
  isHasPermission: PropTypes.bool
};
